/**
 * @deprecated Use ProductFeatureConfig instead. Will be removed in a future version.
 */
export interface FeatureBookingConfig {
    basePath: string;
    freeAccountFeatureName?: string;
    unverifiedAccountFeatureName?: string;
    unverifiedAccountChannelRef?: string;
}
